"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var theme_1 = require("../../../theming/theme");

var theme_pricing_system_1 = require("../../../theming/theme.pricing-system");

var save_button_connected_1 = require("../buttons/save-button/save-button.connected");

var rule_name_field_connected_1 = require("./rule-name-field.connected");

var offset_percent_plus_dispensing_fee_1 = require("./templates/offset-percent-plus-dispensing-fee");

var PharmacyPricingTemplates;

(function (PharmacyPricingTemplates) {
  PharmacyPricingTemplates["OffsetPercentPlusDispensingFee"] = "-Offset % + $DF";
})(PharmacyPricingTemplates = exports.PharmacyPricingTemplates || (exports.PharmacyPricingTemplates = {}));

var RuleDetailsView = function (_super) {
  __extends(RuleDetailsView, _super);

  function RuleDetailsView() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  RuleDetailsView.prototype.renderTemplateText = function () {
    return react_1.default.createElement(react_native_1.View, {
      style: theme_pricing_system_1.pricingStyles.generalContainerView
    }, react_1.default.createElement(react_native_1.View, {
      style: theme_pricing_system_1.pricingStyles.labelView
    }, react_1.default.createElement(react_native_1.Text, {
      style: theme_pricing_system_1.pricingStyles.labelText
    }, "Template:")), react_1.default.createElement(react_native_1.View, {
      style: theme_pricing_system_1.pricingStyles.pricingStaticTextWrapper
    }, react_1.default.createElement(react_native_1.Text, {
      style: theme_pricing_system_1.pricingStyles.pricingStaticTextStyle
    }, this.props.selectedTemplate)));
  };

  RuleDetailsView.prototype.renderTemplate = function () {
    switch (this.props.selectedTemplate) {
      case PharmacyPricingTemplates.OffsetPercentPlusDispensingFee:
        return react_1.default.createElement(offset_percent_plus_dispensing_fee_1.OffsetPercentPlusDispensingFeeTemplate, null);

      default:
        return;
    }
  };

  RuleDetailsView.prototype.render = function () {
    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(react_native_1.Text, {
      style: theme_pricing_system_1.pricingStyles.titleText
    }, "Rule Details"), react_1.default.createElement(react_native_1.View, {
      style: theme_pricing_system_1.pricingStyles.ruleDetailsContainerView
    }, react_1.default.createElement(react_native_1.View, {
      style: theme_pricing_system_1.pricingStyles.flexRow
    }, this.renderTemplateText(), react_1.default.createElement(rule_name_field_connected_1.ConnectedRuleName, null)), this.renderTemplate(), react_1.default.createElement(save_button_connected_1.ConnectedSaveButton, null)));
  };

  RuleDetailsView.prototype.onChangeTemplate = function () {
    return;
  };

  return RuleDetailsView;
}(react_1.default.Component);

exports.RuleDetailsView = RuleDetailsView;

exports.ColoredLine = function () {
  return react_1.default.createElement("hr", {
    style: {
      backgroundColor: theme_1.PurpleScale.darkest,
      borderWidth: 0,
      color: theme_1.PurpleScale.darkest,
      height: 2,
      marginBottom: 15,
      marginTop: 15,
      width: '100%'
    }
  });
};